import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'ct-display-errors',
    templateUrl: './display-errors.component.html'
})
export class DisplayErrorsComponent implements OnInit {
    @Input() errors: string[] = [];
    constructor() { }

    ngOnInit() {
    }

}
